import React, {Component, Fragment} from 'react';
import Classname from 'classnames';
import ResponsiveTable from 'Components/ResponsiveTable';
import Checkbox from 'Components/Checkbox';
import { Status } from 'Components/Status';
import LineItemDetail from 'Components/LineItemDetail';
import TripTableHeader from 'Components/TripTableHeader';
import { scroll } from 'Utils/';

class TransportersTable extends Component {
    state = {
        selectedBids: [],
        trip: null
    };
    toggleAllTransporters = ()=> {
        const { trips } = this.props;
        const { selectedBids } = this.state;
        this.setState({
            selectedBids: trips.length === selectedBids.length?[]:trips
        }, ()=> {
            this.props.setBids(this.state.selectedBids)
        });
    }
    selectTransporter = (transporter)=> {
        let selectedBids = [...this.state.selectedBids];
        const id = transporter.id;
        const selectedTransporter = selectedBids.find((transporter)=> {
            return transporter.id === id;
        });
        if(!selectedTransporter) {
            selectedBids.push(transporter);
        } else {
            selectedBids = selectedBids.filter((transporter)=> {
                return !(transporter.id === id);
            });
        }
        this.setState({
            selectedBids
        }, ()=> {
            this.props.setBids(selectedBids)
        });
    }
    showTripDetail = (trip)=> {
        this.setState({
            trip
        }, scroll)
    }
    hideTripDetail = ()=> {
        this.setState({
            trip: null
        })
    }

    render() {
        const { 
            trips, 
            transporter,
            offset,
            isTransporterBidsLoading,
            pricingBasis,
            paymentCycles,
            vehicleBodyTypes,
            vehicleTypes
        } = this.props;
        const { selectedBids, trip } = this.state;
        return (
            <div>
                <div className="box-shadow mr-15 ml-15 ph-60 pv-20 mb-20 br-5 mb-20">
                    {/* <div className="fs-22 header-dark-color fSemibold mb-40">{transporter.name}</div> */}
                    <TripTableHeader 
                        offset={offset || 0}
                        fetchTrips = {this.props.fetchTrips}
                        viewMode={true}
                        header={transporter.name}
                        vehicleBodyTypes={vehicleBodyTypes}
                        vehicleTypes={vehicleTypes}
                    />
                    <ResponsiveTable >
                        {
                            (trips || []).map((trip, index)=> {
                                
                                const id = trip.id;
                                return(
                                <Fragment>
                                    {index === 0 && <div className="flex flex-middle mb-20 ">
                                        <Checkbox 
                                            type="square" 
                                            checked={selectedBids.length === trips.length}
                                            onCheck={this.toggleAllTransporters}
                                            className="wt-70"
                                        />
                                        <div className="fBold fs-16 header-dark-color wt-150  pl-15 ">Route</div>
                                        <div className="fBold fs-16 header-dark-color wt-250  pl-15 ">Vehicle</div>
                                        <div className="fBold fs-16 header-dark-color wt-150  pl-15 ">Placement</div>
                                        <div className="fBold fs-16 header-dark-color wt-150  pl-15 ">Price</div>
                                        <div className="fBold fs-16 header-dark-color wt-150">TAT</div>
                                        <div className="fBold fs-16 header-dark-color wt-150">Status</div>
                                    </div>}
                                    <div className="fRegular flex flex-middle border-top-light pt-25 pb-25 pr col-1" >
                                        {!trip.isLoiSent && trip.price &&  <Checkbox 
                                            type="square" 
                                            checked={
                                                this.state.selectedBids.findIndex((trip)=> {
                                                    return trip.id === id;
                                                }) > -1
                                            }
                                            onCheck = {this.selectTransporter.bind(this, trip)}
                                            className="wt-70"
                                        />}
                                        {trip.isLoiSent && <div className="wt-70">
                                            {trip.isAccept!==false && trip.isAccept!==true && <span className="fs-10 fSemibold header-dark-color bg-counter pr-2 pl-2 pt-2 pb-2 br-5">LOI Sent</span>}
                                            {trip.isAccept===true && <span className="fs-10 fSemibold header-dark-color bg-accept pr-2 pl-2 pt-2 pb-2 br-5">LOI Accepted</span>}
                                            {trip.isAccept===false && <span className="fs-10 fSemibold header-dark-color bg-reject pr-2 pl-2 pt-2 pb-2 br-5">LOI Rejected</span>}
                                        </div>}
                                        {!trip.price && <div className="fs-10 fSemibold error-color wt-70">No Bid</div>}
                                        <div className="fs-14 table-text-color wt-150 pl-15 curP" onClick={this.showTripDetail.bind(this, trip)}>{trip.from} - {trip.to}</div>
                                        <div className="fs-14 table-text-color wt-250 pl-15">{trip.vehicleTypeName}</div>
                                        <div className="fs-14 table-text-color wt-150 pl-15">{trip.placementTimeFormatted}</div>
                                        <div className="fs-14 fSemibold mb-5 wt-150 pl-15 flex flex-middle">
                                            <span className={Classname("mr-5",{
                                                "header-dark-color": !trip.isCounter,
                                                "challenge-color": trip.isCounter
                                            })}>{trip.price?('₹ ' + trip.price):' - '} </span>
                                            {!trip.isLoiSent && trip.isCounter && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-10">Counter</span>}
                                            {trip.isLoiSent && trip.isCounter && <span className="pl-2 pr-2 pt-2 pb-2 br-5 header-dark-color bg-counter fSemibold fs-10">Counter</span>}
                                        </div>
                                        {trip.tat && <div className="fs-14 table-text-color wt-150">{trip.tat.tatValue + ' ' + trip.tat.tatUnit.tatUnitName}</div>}
                                        {!trip.tat && <div className="fs-14 table-text-color wt-150">-</div>}
                                        <Status status={trip.status}/>
                                        
                                    </div>
                                </Fragment>
                                )
                            })
                        }
                        {!(trips && trips.length > 0) && !isTransporterBidsLoading && <div className="fBold fs-14 caption-color pl-5 mt-50 mb-20 tCenter">No Bid found</div>}
                    </ResponsiveTable>
                </div>
                {trip && <LineItemDetail pricingBasis={pricingBasis} paymentCycles={paymentCycles} lineItem = {trip} openLineItem = {true} hideLineItem={this.hideTripDetail}/>}
            </div>

        )
    }
}

export default TransportersTable;
